import { DataList, Separator, Stack, Text } from "@chakra-ui/react"
import { UI } from "components"
import useVouchers from "hooks/useVouchers"

export default function Resume(){

    const vouchers = useVouchers()

    const total = () => {
        let total = 0
        vouchers.data?.stock?.map(item => { total = total + item.stock })
        return total
    }

    return(
    <UI.Box loading={vouchers.isFetching}>
        <Text children="Vouchers disponíveis:" color="GrayText" />
        <Stack gap={4}>
            <Text children={`${total()} vouchers`} fontSize="lg" fontWeight="bold" color="green.fg" />

            <DataList.Root orientation="horizontal" mt={4} gap={2}>
                { vouchers.data?.stock?.map(item => {
                    total.current = (total + item.stock)

                    return(
                    <DataList.Item key={item.product_kit.id}>
                        <DataList.ItemLabel>{item.product_kit.label}</DataList.ItemLabel>
                        <DataList.ItemValue>{item.stock} vouchers</DataList.ItemValue>
                    </DataList.Item>
                    )
                })}
            </DataList.Root>

            <Separator />

            <DataList.Root orientation="horizontal" gap={2}>
                <DataList.Item>
                    <DataList.ItemLabel>Utilizados:</DataList.ItemLabel>
                    <DataList.ItemValue>{vouchers.data?.used} vouchers</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Total comprado:</DataList.ItemLabel>
                    <DataList.ItemValue>{vouchers.data?.orders} vouchers</DataList.ItemValue>
                </DataList.Item>
            </DataList.Root>
        </Stack>
    </UI.Box>
    )
}